import classnames from 'classnames';
import React, { useRef, useState } from 'react';
import globals from '../../globals';
import MarbleverseConnector from '../../lib/MarbleverseConnector';

const { cdn } = globals;

const emailRegExp = /\S+@\S+\.\S+/;

type Mode = 'idle' | 'loading' | 'success' | 'error';

interface Props {
  campaign: number;
  header?: string;
  callToAction?: string;
  buttonText?: string;
  children?: React.ReactNode;
}
const SignUpForm = (props: Props) => {
  const { campaign, children, header, callToAction, buttonText } = props;
  // const [error, setError] = useState();
  const [mode, setMode] = useState<Mode>('idle');
  const [email, setEmail] = useState('');

  const onKeyDown = event => {
    if (event.keyCode !== 13) return;
    event.preventDefault();
    onSignUp();
  };

  const onChange = event => setEmail(event?.target?.value);

  const onSignUp = () => {
    setMode('loading');
    MarbleverseConnector.addEmailToCampaign({ email, campaign })
      .then(() => setMode('success'))
      .catch(() => setMode('error'));
  };

  const openHomePage = () => window.open('/', 'marbleverse');

  const loading = mode === 'loading';
  const invalidEmail = !emailRegExp.test(email);
  const buttonDisabled = loading || invalidEmail;
  const inputRef = useRef();
  return (
    <div className="SignUpForm">
      <div
        className="header"
        style={{
          backgroundImage: `url('${cdn}/images/signup.form.header.backdrop.jpeg')`
        }}
      >
        <div className="logo" onClick={openHomePage}>
          <img src={`${cdn}/images/logo-white.svg`} alt="Marbleverse" />
        </div>
        <div className="caption">{header}</div>
      </div>
      <form>
        <div className="children">{children}</div>
        {callToAction && <div className="call-to-action">{callToAction}</div>}
        <div className="form-row">
          <input
            type="text"
            placeholder="Your e-mail address"
            value={email}
            ref={inputRef}
            disabled={mode === 'loading'}
            onKeyDown={onKeyDown}
            onChange={onChange}
          />
          <div
            className={classnames('button', { disabled: buttonDisabled, wait: loading })}
            onClick={buttonDisabled ? undefined : onSignUp}
          >
            {loading ? 'Wait...' : buttonText || 'Sign Up'}
          </div>
        </div>
        <div className="footer">
          By submitting this form, you agree to our{' '}
          <a href="https://app.marblever.se/privacy" target="_privacy">
            privacy policy
          </a>{' '}
          and consent to the processing of your personal data. You can withdraw your consent at any
          time.
        </div>
        <div className="feedback">
          {(mode === 'idle' || mode === 'loading') && <span className="empty">&nbsp;</span>}
          {mode === 'success' && (
            <span className="success">Thanks, you've been added to our waiting list!</span>
          )}
          {mode === 'error' && <span className="error">An error occurred. Please try again.</span>}
        </div>
      </form>
    </div>
  );
};

export default SignUpForm;
